import { useGate, useStore } from 'effector-react'
import { useMemo } from 'react'
import {
  Registration,
  registrationStepModel,
  useTitle,
} from '~/features/Registration'
import { PageContainer } from '~/shared/ui/PageContainer'

export const RegistrationPage = () => {
  useGate(registrationStepModel.Gate)

  const {
    isPassportStep,
    isDriverLicenseStep,
    isConfirmCodeStep,
    isErrorStep,
  } = useStore(registrationStepModel.$currentStepFlags)

  const title = useTitle()

  const pageContainerProps = useMemo(() => {
    return {
      ...(isPassportStep || isDriverLicenseStep
        ? { onBack: registrationStepModel.goToBackStep }
        : {}),
      ...(isConfirmCodeStep
        ? { contentFillColor: null, onBack: registrationStepModel.goToBackStep }
        : {}),
      ...(isErrorStep ? { onBack: registrationStepModel.goToConfirmStep } : {}),
    }
  }, [isConfirmCodeStep, isDriverLicenseStep, isErrorStep, isPassportStep])

  return (
    <PageContainer
      title='Регистрация'
      backTitle={title}
      canBack
      {...pageContainerProps}
    >
      <Registration />
    </PageContainer>
  )
}
